"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadioContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
exports.StyledRadioContainer = styled_components_1.default.div(function (_a) {
    var Typography = _a.theme.Typography, isDefaultValue = _a.isDefaultValue;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    line-height: 20px;\n    width: calc(100% - 24px); /* 24px is the width of the radioButton's circle icon */\n\n    .radio-label {\n      font-size: ", ";\n      font-weight: ", ";\n    }\n\n    .label-description {\n      font-size: ", ";\n      font-weight: 400;\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    line-height: 20px;\n    width: calc(100% - 24px); /* 24px is the width of the radioButton's circle icon */\n\n    .radio-label {\n      font-size: ", ";\n      font-weight: ", ";\n    }\n\n    .label-description {\n      font-size: ", ";\n      font-weight: 400;\n    }\n  "])), Typography.Sizes.smd, isDefaultValue ? 700 : 400, Typography.Sizes.smd);
});
var templateObject_1;
